export const enviroment = {
  baseApi: "https://beemove-webapp.azurewebsites.net",
  // baseApi: "http://localhost:5032",
  baseUrl: "http://localhost:3000/",
  MapsKey: "AIzaSyCaCcyoHcSIwb5DSBtku4XdwrXQZ-elwBQ",
};